import { useMutation } from '@tanstack/react-query';
import { FormikErrors, FormikValues } from 'formik';
import { api } from '@/modules/common/api/index.ts';
import { queryClient } from '@/modules/common/query.ts';
import { withErrorHandling } from '@/modules/common/utils/error-utils.tsx';
import { CURRENT_USER_ACTIVITIES_QUERY_KEY } from '@/modules/investor-dashboard/queries/activity.tsx';
import { CreateTransferRequest } from 'api';

export const useCreateTransferMutation = ({
  setErrors,
  registerId,
}: {
  setErrors: (errors: FormikErrors<FormikValues>) => void;
  registerId?: number;
}) => {
  return useMutation({
    mutationFn: async (payload: CreateTransferRequest) => {
      const response = await withErrorHandling(
        api.v1.createTransferV1SrTransfersPost(
          payload,
          registerId ? { headers: { ['xRegister-ID']: registerId } } : undefined,
        ),
        {
          loading: 'Creating transaction...',
          success: 'Transaction created',
          setErrors,
        },
      );
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries([CURRENT_USER_ACTIVITIES_QUERY_KEY]);
    },
  });
};
